import { type CardReportingItem } from "components/cards/CardReporting/CardReporting";
import { type QueryFilter, lineChartFactory, fallbackToZero } from "features/Library/Common/utils/performanceUtils";
import { reportingColors } from "features/Library/Common/utils/constants";
import * as contentReportingService from "features/Reporting/services/contentReportingService";
import type { PhishingCampaignDetails } from "features/Reporting/types/content";

export const fetchDailyData = async ({ queryKey }: QueryFilter) => {
  const [_key, filter] = queryKey;
  const { data } = await contentReportingService.getPhishingCampaignLineChart(filter);
  const formattedData = lineChartFactory(data);

  return {
    lineData: {
      xData: [formattedData.Date, formattedData.Date, formattedData.Date, formattedData.Date],
      yData: [
        formattedData.EmailsSent,
        formattedData.EmailsOpened,
        formattedData.EmailsClicked,
        formattedData.DataSubmitted,
      ],
    },
  };
};
export const fetchEngagementQuery = async ({ queryKey }: QueryFilter): Promise<CardReportingItem[]> => {
  const [_key, filter] = queryKey;
  const { data } = await contentReportingService.getPhishingCampaignEngagement(filter);
  return [
    {
      statDescription: "Emails Sent",
      stat: fallbackToZero(data.EmailsSent),
      popupBody: "The number of emails sent",
    },
    {
      statDescription: "Opened",
      stat: fallbackToZero(data.EmailsOpened),
      popupBody: "The number of emails opened",
    },
    {
      statDescription: "Clicked",
      stat: fallbackToZero(data.EmailsClicked),
      popupBody: "The number of clicks on email links or buttons",
    },
    {
      statDescription: "Submitted Data",
      stat: fallbackToZero(data.DataSubmitted),
      popupBody: "The number of submissions of personal data",
    },
  ];
};
export const fetchChartQuery = async ({ queryKey }: QueryFilter) => {
  const [_key, filter] = queryKey;
  const { data } = await contentReportingService.getPhishingCampaignChart(filter);
  const barData = [
    {
      id: "piiPhishing",
      category: "PII Phishing",
      value: data["PII Phishing"],
      fillColor: reportingColors.blue,
    },
    {
      id: "passwordPhishing",
      category: "Password Phishing",
      value: data["Password Phishing"],
      fillColor: reportingColors.greenLight,
    },
    {
      id: "malwareDownload",
      category: "Malware Download",
      value: data["Malware Download"],
      fillColor: reportingColors.yellow,
    },
    {
      id: "financialScam",
      category: "Financial Scam",
      value: data["Financial Scam"],
      fillColor: reportingColors.red,
    },
    {
      id: "other",
      category: "Other",
      value: data.Other,
      fillColor: reportingColors.greyLight,
    },
  ];
  return barData;
};
export const fetchDetailsQuery = async ({ queryKey }: QueryFilter): Promise<PhishingCampaignDetails[]> => {
  const [_key, filter] = queryKey;
  const { data } = await contentReportingService.getPhishingCampaignDetails(filter);
  return data.map((item: PhishingCampaignDetails, index: number) => ({
    ...item,
    id: index,
  }));
};
